import React from "react";

export default function Main({ children }) {
  return (
    <main className="min-h-[calc(100vh-140px)] mt-6 mb-6 text-zinc-500 px-6">
      {children}
    </main>
  );
}
